import { withInstall} from '@/utils/common'
import tinymceVue from './src/editor.vue';

export const Tinymce = withInstall(tinymceVue);